/* ================================
   Helper
================================ */
function extractHandle(url) {
  try {
    const parts = url.split("/products/");
    if (parts[1]) return parts[1].split("?")[0].replace("/", "");
  } catch (e) {}
  return null;
}

/* ================================
   Product API + Cache
================================ */
const productPriceCache = {};

async function fetchProductPrice(handle) {
  try {
    const res = await fetch(`/products/${handle}.js`);
    if (!res.ok) return null;
    const productData = await res.json();

    // Price (first variant)
    const price =
      typeof productData.price === "number"
        ? productData.price
        : productData.variants?.[0]?.price ?? null;

    // URL (Shopify product URL)
    const url = productData?.url || `/products/${handle}`;

    return { price, url };
  } catch (e) {
    console.error(`Error fetching product ${handle}`, e);
    return null;
  }
}

/* ================================
   SINGLE MASTER FUNCTION
================================ */
async function processInstaModal(instaContainer) {
  if (!instaContainer) return;

  const modal = instaContainer.querySelector("dialog");
  if (!modal) return;

  /* ---------- 1. Inject product cards + price ---------- */
  const productWrap = modal.querySelector(
    ".Vtl-InstagramFeedModal__InstagramTaggedProducts"
  );

  if (productWrap) {
    const links = productWrap.querySelectorAll(
      ".Vtl-InstagramFeedModal__InstagramModalProductLink"
    );

    for (const link of links) {
      if (link.dataset.processed === "true") continue;
      link.dataset.processed = "true";

      const handle = extractHandle(link.href);
      if (!handle) continue;

      const title = handle.replace(/-/g, " ");

      // Insert card
      const cardHTML = `
        <a class="custom_text_cards" target="_blank" href="/products/${handle}">
          <span class="finaltext">${title}</span>
          <span class="product-price">...</span>
          <span class="btn-buy">Buy Now</span>
        </a>
      `;
      link.insertAdjacentHTML("afterend", cardHTML);

      // Fetch and insert price
      const card = link.nextElementSibling;
      const priceSpan = card?.querySelector(".product-price");
      if (priceSpan) {
        const priceData = await fetchProductPrice(handle);
        if (priceData?.price != null) {
          priceSpan.textContent = `${(priceData.price / 100).toFixed(2)} ₪`;
        } else {
          priceSpan.textContent = "...";
        }
      }
    }
  }

  /* ---------- 2. Replace _small → _large images ---------- */
  const info = modal.querySelector(".vtl-if-modal__post-info");
  if (info) {
    info.querySelectorAll('img[src*="_small"]').forEach(img => {
      const src = img.getAttribute("src");
      if (!src) return;
      const large = src.replace("_small", "_large");
      if (large !== src) img.src = large;
    });
  }

  /* ---------- 3. Mobile header link → description ---------- */
  const mobileLink = modal.querySelector(".vtl-if-modal__mobile-header a");
  const desc = modal.querySelector(".vtl-if-modal__post-description");
  const p = desc?.querySelector("p");

  if (mobileLink && desc && p) {
    if (!desc.querySelector(".custom-mobile-header-link")) {
      p.insertAdjacentHTML(
        "afterend",
        `
        <div class="custom-mobile-header-link">
          <a href="${mobileLink.href}" target="_blank" rel="noreferrer">
            ${mobileLink.innerText.trim()}
            <svg class="icon-external-link" width="10" height="10"
                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                <path d="M576 24v127.984c0 21.461-25.96 31.98-40.971 16.971l-35.707-35.709-243.523 243.523c-9.373 9.373-24.568 9.373-33.941 0l-22.627-22.627c-9.373-9.373-9.373-24.569 0-33.941L442.756 76.676l-35.703-35.705C391.982 25.9 402.656 0 424.024 0H552c13.255 0 24 10.745 24 24zM407.029 270.794l-16 16A23.999 23.999 0 0 0 384 303.765V448H64V128h264a24.003 24.003 0 0 0 16.97-7.029l16-16C376.089 89.851 365.381 64 344 64H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V287.764c0-21.382-25.852-32.09-40.971-16.97z"></path>
            </svg>
          </a>
        </div>
        `
      );
    }
  }
}

/* ================================
   Click / Arrow handling
================================ */
document.addEventListener("click", e => {
  const arrow = e.target.closest(".Vtl-InstagramFeedModal__SliderArrow");
  const post = e.target.closest(".Vtl-InstagramFeedLayout__Post");
  const main = e.target.closest("#vitals-instagram-feed");

  if (!arrow && !post) return;

  setTimeout(() => {
    processInstaModal(main);
  }, arrow ? 50 : 300);
});

/* ================================
   Swipe handling
================================ */
(function () {
  let startX = 0,
    startY = 0,
    moved = false,
    active = false;

  document.addEventListener("pointerdown", e => {
    if (!e.target.matches(".Vtl-InstagramFeedModal__InstagramPostMedia img, video"))
      return;

    active = true;
    moved = false;
    startX = e.clientX;
    startY = e.clientY;
  });

  document.addEventListener("pointermove", e => {
    if (!active) return;
    if (Math.abs(e.clientX - startX) > 5 || Math.abs(e.clientY - startY) > 5) {
      moved = true;
    }
  });

  document.addEventListener("pointerup", () => {
    if (active && moved) {
      setTimeout(() => {
        processInstaModal(document.querySelector("#vitals-instagram-feed"));
      }, 700);
    }
    active = false;
  });
})();

/* ================================
   Mutation Observer
================================ */
(function () {
  const container = document.querySelector("#vitals-instagram-feed");
  if (!container) return;

  let raf = null;

  const observer = new MutationObserver(() => {
    if (raf) cancelAnimationFrame(raf);

    raf = requestAnimationFrame(() => {
      processInstaModal(container);
    });
  });

  observer.observe(container, {
    childList: true,
    subtree: true,
  });
})();

(function() {
  let touchStartX = 0;
  let touchStartY = 0;
  let isScrolling = null;
  document.addEventListener('touchstart', function(e) {
    const modal = e.target.closest('.Vtl-InstagramFeedModal__InstagramPostMedia') || 
    e.target.closest('.vtl-if-modal__post-media');
    
    if (!modal) return;
    
    if (e.touches.length > 0) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      isScrolling = null;
    }
  }, { passive: true, capture: true });
  
  document.addEventListener('touchmove', function(e) {
    const modal = e.target.closest('.Vtl-InstagramFeedModal__InstagramPostMedia') || 
                  e.target.closest('.vtl-if-modal__post-media');
    
    if (!modal) return;
    
    if (e.touches.length > 0) {
      const touchX = e.touches[0].clientX;
      const touchY = e.touches[0].clientY;
      const deltaX = Math.abs(touchX - touchStartX);
      const deltaY = Math.abs(touchY - touchStartY);

      if (isScrolling === null && (deltaX > 10 || deltaY > 10)) {
        isScrolling = deltaY > deltaX;
      }
      if (isScrolling === true) {
        e.stopImmediatePropagation();
      }
    }
  }, { capture: true, passive: false });

  document.addEventListener('touchend', function() {
    isScrolling = null;
  }, { passive: true, capture: true });
  
  const style = document.createElement('style');
  style.id = 'vitals-scroll-swipe-fix';
  
  if (!document.getElementById('vitals-scroll-swipe-fix')) {
    style.innerHTML = `
      /* Modal container - dono direction allow */
      .Vtl-InstagramFeedModal__InstagramPostMedia,
      .vtl-if-modal__post-media {
        touch-action: pan-y pan-x !important;
        overflow-y: auto !important;
        -webkit-overflow-scrolling: touch !important;
      }
      
      .Vtl-InstagramFeedModal__InstagramPostMediaContainer {
        touch-action: pan-y pan-x !important;
        overflow: visible !important;
      }
      
      /* Video/Image touchable */
      .Vtl-InstagramFeedModal__InstagramPostVideo,
      .vtl-if-modal__post-video,
      .Vtl-InstagramFeedModal__InstagramPostMediaContainer video,
      .Vtl-InstagramFeedModal__InstagramPostMediaContainer img {
        pointer-events: auto !important;
        touch-action: pan-y pan-x !important;
      }
      
      /* Swipeable ko dono directions dein */
      .Vtl-Swipeable {
        touch-action: pan-y pan-x !important;
      }
    `;
    document.head.appendChild(style);
  }
})();